import React from 'react'
import gql from 'graphql-tag'
import { useGlobalContext } from 'components/context'
import { useQuery } from 'react-apollo'
import ValueMetric from '../../types/value'
import { FieldAggregationMetric, FieldAggregationMetricVariables } from './gql-types/FieldAggregationMetric'
import MetricPlaceholder from '../metric-placeholder'


const QUERY = gql`
	query FieldAggregationMetric($id: ID!, $teamId: ID) {
		fieldAggregationMetric(id: $id) {
			id
			name
			result(teamId: $teamId) {
				value
				formLink {
					form {
						id
						title
					}
					record {
						id
						name
					}
					field {
						id
						title
					}
				}
			}
		}
	}
`


type Props = {
	id: string
}

const FieldAggregationMetricWrapper = ({ id }: Props) => {
	const globalContext = useGlobalContext()
	const { loading, data } = useQuery<FieldAggregationMetric, FieldAggregationMetricVariables>(QUERY, {variables: {id, teamId: globalContext.currentTeam?.id}})
	if (loading) {
		return <MetricPlaceholder />
	}
	if (!data || !data.fieldAggregationMetric) {
		return <div>error</div>
	}
	return (
		<ValueMetric {...data?.fieldAggregationMetric} />
	)

}

export default FieldAggregationMetricWrapper